/* eslint-disable complexity */
import React, { useEffect, useState } from 'react';
import { Upload, Modal, Space, UploadFile, UploadProps, message } from 'antd';
import MainButton from 'components/MainButton/MainButton';
import { RcFile, UploadListType } from 'antd/lib/upload/interface';
import { AppState } from 'store';
import { useSelector } from 'react-redux';
import { messages } from 'constants/validate/message';
import { UploadOutlined } from '@ant-design/icons';
import styles from './style.module.scss';

const ModalUploadBaseLib: React.FC<{
  open: boolean;
  setModal: (active: boolean) => void;
  updateFile?: (data: { file: FormData; fileName: string }) => void;
  clearStateUpload: () => void;
}> = ({ open, setModal, updateFile, clearStateUpload }) => {
  const { uploaded } = useSelector((state: AppState) => state.pages.upload);

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => setFileList(newFileList);

  useEffect(() => {
    if (uploaded) {
      setModal(false);
      clearStateUpload();
    }
  }, [uploaded]);

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
  };

  const handleUpload = (fileList: UploadFile[]) => {
    if (!fileList.length) {
      return;
    }
    const isValidJsonFile = fileList[0].type === 'application/json';
    if (!isValidJsonFile) {
      message.error(messages.invalidFile);
    }
    const isLt500KB = fileList[0]?.size ? fileList[0]?.size / 1024 < 500 : undefined;
    if (!isLt500KB) {
      message.error(messages.fileTooLarge);
    }
    if (isValidJsonFile && updateFile) {
      const formData = new FormData();
      fileList.forEach((file) => {
        formData.append('file', file.originFileObj as RcFile);
      });
      updateFile({ file: formData, fileName: fileList[0].name });
    }
  };

  return (
    <Modal
      title="ファイルのアップロード"
      centered
      open={open}
      onOk={() => setModal(false)}
      onCancel={() => setModal(false)}
      footer={null}
    >
      <Upload.Dragger maxCount={1} {...props} onChange={handleChange} listType={'picture' as UploadListType}>
        <p className="ant-upload-drag-icon">
          <img src="/images/icon-wrapper-h.png" alt="icon-wrapper-h" />
        </p>
        <p className="ant-upload-text">ここにファイルをドラッグ＆ドロップ</p>
        <p className="ant-upload-hint">またはここをクリックし、ファイルを指定してください。</p>
      </Upload.Dragger>
      <div className={styles.buttonUpload}>
        <Space>
          <MainButton
            text={
              <span>
                <UploadOutlined /> このファイルをアップロード
              </span>
            }
            onClick={() => {
              handleUpload(fileList);
              setModal(false);
            }}
          />
        </Space>
      </div>
    </Modal>
  );
};

export default ModalUploadBaseLib;
